// reducers
//const defaultFlags = require('../../initFlags/featureFlags').flags;

function variants(state = {}, action) {
  switch (action.type) {
    case 'AMPLITUDE_INIT_SUCCESS':
      return action.variants;

    default:
      return state;
  }
}

export default variants;
